module.exports = __webpack_public_path__ + "img/h5-code.e2ae6ec5.png";